import * as React from "react";
import ConfigurationBankAccountsView from "./ConfigurationBankAccountsView";
import ConfigurationBankTransactionRulesView from "./ConfigurationBankTransactionRulesView";

/**
 * The "Finance" tab of the configuration: the settings of the forecast which are rarely changed.
 * The rules have an anchor for links from the forecast.
 */
const ConfigurationFinanceView: React.FC = () => (
    <div className="space-y-6 px-4 sm:px-6 lg:px-0">
        <ConfigurationBankAccountsView/>
        <div id="rules">
            <ConfigurationBankTransactionRulesView/>
        </div>
    </div>
);

export default ConfigurationFinanceView;
